module.exports = function (Loader) {
    const mapHolder = document.querySelector('#AboutMap');

    if (typeof (mapHolder) != 'undefined' && mapHolder != null) {
        const LatLng = {
                lat: parseFloat(mapHolder.dataset.lat),
                lng: parseFloat(mapHolder.dataset.lng)
            },
            mapZoom = parseFloat(mapHolder.dataset.zoom);

        //GMaps
        const loader = new Loader({
            apiKey: "AIzaSyCLfZsma7kWs95uB9qL1-lHneQufC52EZk",
            version: "weekly",
            libraries: ["places"]
        });

        const mapOptions = {
            center: LatLng,
            zoom: mapZoom,
            mapTypeId: "terrain",
            // styles: mapStyles,
        };

        // Define the LatLng coordinates for the polygon.
        const triangleCoords = [{
                lat: 51.513343,
                lng: -0.079302
            },
            {
                lat: 51.513777,
                lng: -0.07916
            },
            {
                lat: 51.513936,
                lng: -0.079599
            },
            {
                lat: 51.514104,
                lng: -0.079988
            },
            {
                lat: 51.514488,
                lng: -0.079556
            },
            {
                lat: 51.514844,
                lng: -0.079151
            },
            {
                lat: 51.514908,
                lng: -0.079066
            },
            {
                lat: 51.515056,
                lng: -0.079326
            },
            {
                lat: 51.515411,
                lng: -0.078823
            },
            {
                lat: 51.515576,
                lng: -0.07905
            },
            {
                lat: 51.516067,
                lng: -0.078441
            },
            {
                lat: 51.515845,
                lng: -0.078033
            },
            {
                lat: 51.515807,
                lng: -0.07788
            },
            {
                lat: 51.516642,
                lng: -0.076842
            },
            {
                lat: 51.517546,
                lng: -0.077483
            },
            {
                lat: 51.518095,
                lng: -0.077762
            },
            {
                lat: 51.518319,
                lng: -0.07802
            },
            {
                lat: 51.518511,
                lng: -0.07818
            },
            {
                lat: 51.518583,
                lng: -0.077578
            },
            {
                lat: 51.51858,
                lng: -0.077515
            },
            {
                lat: 51.518208,
                lng: -0.076952
            },
            {
                lat: 51.518289,
                lng: -0.076358
            },
            {
                lat: 51.5182,
                lng: -0.07634
            },
            {
                lat: 51.518242,
                lng: -0.075841
            },
            {
                lat: 51.518374,
                lng: -0.074379
            },
            {
                lat: 51.516982,
                lng: -0.073235
            },
            {
                lat: 51.517013,
                lng: -0.072723
            },
            {
                lat: 51.517043,
                lng: -0.072358
            },
            {
                lat: 51.517113,
                lng: -0.07179
            },
            {
                lat: 51.517307,
                lng: -0.070534
            },
            {
                lat: 51.51706,
                lng: -0.070293
            },
            {
                lat: 51.516088,
                lng: -0.06966
            },
            {
                lat: 51.516168,
                lng: -0.069486
            },
            {
                lat: 51.515901,
                lng: -0.069209
            },
            {
                lat: 51.515471,
                lng: -0.068933
            },
            {
                lat: 51.51501,
                lng: -0.068619
            },
            {
                lat: 51.514967,
                lng: -0.067955
            },
            {
                lat: 51.513886,
                lng: -0.067811
            },
            {
                lat: 51.513828,
                lng: -0.06832
            },
            {
                lat: 51.513581,
                lng: -0.069071
            },
            {
                lat: 51.513506,
                lng: -0.069328
            },
            {
                lat: 51.513321,
                lng: -0.069231
            },
            {
                lat: 51.512812,
                lng: -0.068821
            },
            {
                lat: 51.512656,
                lng: -0.068681
            },
            {
                lat: 51.512192,
                lng: -0.068434
            },
            {
                lat: 51.512142,
                lng: -0.068595
            },
            {
                lat: 51.512027,
                lng: -0.068606
            },
            {
                lat: 51.511942,
                lng: -0.069059
            },
            {
                lat: 51.511467,
                lng: -0.068748
            },
            {
                lat: 51.51118,
                lng: -0.068608
            },
            {
                lat: 51.510943,
                lng: -0.07143
            },
            {
                lat: 51.510895,
                lng: -0.072692
            },
            {
                lat: 51.510846,
                lng: -0.07418
            },
            {
                lat: 51.510871,
                lng: -0.075078
            },
            {
                lat: 51.510558,
                lng: -0.074997
            },
            {
                lat: 51.510492,
                lng: -0.07551
            },
            {
                lat: 51.511069,
                lng: -0.075682
            },
            {
                lat: 51.511038,
                lng: -0.077034
            },
            {
                lat: 51.511556,
                lng: -0.077147
            },
            {
                lat: 51.511559,
                lng: -0.077367
            },
            {
                lat: 51.511412,
                lng: -0.077699
            },
            {
                lat: 51.511306,
                lng: -0.078
            },
            {
                lat: 51.511211,
                lng: -0.078519
            },
            {
                lat: 51.511433,
                lng: -0.078597
            },
            {
                lat: 51.511792,
                lng: -0.078902
            },
            {
                lat: 51.512366,
                lng: -0.079401
            },
            {
                lat: 51.512456,
                lng: -0.0792
            },
            {
                lat: 51.51264,
                lng: -0.079391
            },
            {
                lat: 51.512947,
                lng: -0.079592
            },
            {
                lat: 51.513341,
                lng: -0.079498
            },
            {
                lat: 51.513316,
                lng: -0.079315
            },
            {
                lat: 51.513341,
                lng: -0.079303
            }
        ];

        // Polygon Object
        const polygonSettings = {
            paths: triangleCoords,
            strokeColor: "#3D3DA8",
            strokeOpacity: 0.8,
            strokeWeight: 3,
            fillColor: "#3D3DA8",
            fillOpacity: 0.35,
        }

        // Promise
        loader.load()
            .then((google) => {
                // Init Map
                const map = new google.maps.Map(mapHolder, mapOptions);
                // Construct the polygon.
                new google.maps.Polygon(polygonSettings).setMap(map);
                // Construct the marker.
                // new google.maps.Marker({
                //     position: LatLng,
                //     map,
                // });
            })
            .catch(e => {
                // do something
                console.log(e);
            });
    }
}